import * as React from "react";

export const renderMarketsCount = (componentPrefix: string, count: number) =>
    <div className={`rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__market-count`} data-uat={`div-ev-list-${componentPrefix}-market-count`}>
        {count > 0 && <span className={`rj-ev-list__${componentPrefix}__market-count-number`} data-uat={`span-ev-list-${componentPrefix}-market-count-number`}>{count}</span>}
        <span className={`rj-ev-list__${componentPrefix}__market-count-arrow`} data-uat={`span-ev-list-${componentPrefix}-market-count-arrow`}></span>
    </div>